import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Get Shopify Status
  [types.GET_SHOPIFY_STATUS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_STATUS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_SHOPIFY_STATUS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
